import React from 'react';

import InputContainer from './input_container.jsx';
import UrlTextarea from './url_textarea.jsx';

import {
  getErrorMessage as getUrlErrorMessage,
  makeOnPasteHandler
} from 'zoomforth_zfutils/url_validators.js';


export default ({
  name,
  url,
  dark,
  error,
  focusOnMount,
  forceHttps=false,
  isSchemeRequired=false,
  children,
  onBlur,
  onFocus,
  onUrlChange,
  ...props
})=> {

  return (
    <InputContainer
      dark={dark}
      name={name}
      error={
        error ?
          error
        : url ?
          getUrlErrorMessage(url, { forceHttps, isSchemeRequired })
        :
          null
      }
      {...props}
    >
      <UrlTextarea
        url={url} 
        onUrlChange={(url)=> { onUrlChange(url); }}
        onPaste={makeOnPasteHandler(url, onUrlChange)}
        {...{onFocus, onBlur, focusOnMount}}
      />

      {children}
    </InputContainer>
  );

};
